import React from 'react';
import moment from 'moment';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Camera from '../../components/Camera/Camera';
import RunningTime from '../../components/RunningTime/RunningTime';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Input from '../../components/Input/Input';
import Button from '@material-ui/core/Button';
import axios from '../../config/axiosInstance';
import timeclockInstance from '../../config/timeclockInstance';
import { Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

export class RegisterActivity extends React.Component {
    state = {
        os: null,
        openModal: false,
        checked: false,
        dateTime: moment().format('YYYY-MM-DD HH:mm'),
        workActivityObs: null,
    }

    openModal = () => {
        this.setState({ openModal: true });
    };

    closeModal = () => {
        this.setState({ openModal: false });
    };


    registerActivity = async () => { //essa função via ir para o aquivo principal
        const jwt = require('jsonwebtoken');
        const decodedToken = jwt.decode(localStorage.token);
        const fetchResult = await timeclockInstance.get(`/record-reg/companies/${decodedToken.cpf}`); //requisição temporaria
        if (this.props.allActivities.find(i => i.customId == this.state.os)) {
            this.openModal();
        } else {
            axios
                .post('workActivity', {
                    companyId: decodedToken.companyId,
                    customId: this.state.os,
                    byUser: decodedToken.id,
                    employeeId: fetchResult.data.companies.find(e => e.employeeId).employeeId, // pegar variavel do decodedToken
                    type: 'I',
                    workActivityObs: this.state.workActivityObs,
                    picturePath: this.camera.takePicture(),
                    isManual: this.state.checked,
                    dtRegister: (moment(this.state.dateTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm')),
                    inParentId: null,
                }, { headers: { Authorization: ` Bearer ${localStorage.token}` } })
                .then((response) => {
                })
                .catch((error) => {
                    this.props.onMessage(error);
                });
            setTimeout(() => window.location.reload(), 1000);
        }
    };

    handleChange = (event, type) => {
        let newDateTime = { ...this.state.dateTime };
        switch (type) {
            case 'customId':
                this.setState({ os: event.target.value });
                break;

            case 'datetime':
                newDateTime = event;
                this.setState({ dateTime: newDateTime });
                break;

            case 'workActivityObs':
                this.setState({ workActivityObs: event.target.value });
                break;

            default:
                break;
        }
    };

    handleChangeDate = (event) => {
        this.setState({ [event.target.name]: event.target.checked });
        if (event.target.checked == false) {
            this.setState({ dateTime: moment().format('YYYY-MM-DD HH:mm') })
        } else { }
    };

    render() {

        return (
            <Paper elevation={0}>
                <Typography style={{ textAlign: 'center' }}>Iniciar sua Atividade</Typography>
                <div style={{ textAlign: 'center', width: '100%' }}>
                    <Typography
                        variant="body1"
                        color="textSecondary"
                        paragraph
                    >
                    </Typography>
                    <Input
                        inputProps={{ maxLength: 15, style: { textTransform: "uppercase" } }}
                        elementType="input"
                        label="OS:"
                        value={this.state.os}
                        margin="normal"
                        variant="outlined"
                        onChange={event => this.handleChange(event, 'customId')}
                        helperText={
                            (this.props.allActivities.find(i => i.customId == this.state.os) ? 'Essa os já esta em uso' : '')
                        }
                        fullWidth
                    />
                    <Camera
                        innerRef={(node) => {
                            this.camera = node;
                        }} />
                </div>
                <div>
                    <Typography>
                        <Switch
                            checked={this.state.checked}
                            onChange={this.handleChangeDate}
                            color="primary"
                            name="checked"
                        />
                        Colocar data e hora Manualmente.
                    </Typography>

                    {!this.state.checked ? (<div style={{ textAlign: 'center' }}><RunningTime /></div>) :
                        <Input
                            elementType='dateTimePicker'
                            label="Data e Horário"
                            margin="normal"
                            variant="outlined"
                            value={this.state.dateTime}
                            onChange={event => this.handleChange(event, 'datetime')}
                            required
                            fullWidth
                        />}

                </div>
                <TextField
                    elementType="text"
                    label="Descrição (Opcional):"
                    margin="normal"
                    variant="outlined"
                    onChange={event => this.handleChange(event, 'workActivityObs')}
                    fullWidth
                />
                {!this.state.os ?
                    (<div style={{ textAlign: 'center', marginBottom: '30px' }}>
                        <Button
                            disabled={true}
                            variant="contained"
                            style={{ width: '100%', backgroundColor: 'gray', color: '#fff' }}
                            onClick={() => this.registerActivity()}
                        >
                            Iniciar
                        </Button>
                    </div>)
                    :
                    <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                        <Button
                            variant="contained"
                            style={{ width: '100%', backgroundColor: '#2b8a15', color: '#fff' }}
                            onClick={() => this.registerActivity()}
                        >
                            Iniciar
                        </Button>
                    </div>}

                <Dialog
                    open={this.state.openModal}
                    onClose={this.closeModal}
                    aria-labelledby="title"
                    aria-describedby="description"
                >
                    <IconButton aria-label="close" style={{ position: 'absolute', right: '1px' }} onClick={this.closeModal}>
                        <CloseIcon />
                    </IconButton>
                    <DialogTitle id="title" style={{ textAlign: 'center', color: 'red' }}>
                        OS DUPLICADA!
                        <DialogContentText id="description" style={{ padding: 2 }}>
                            Escolha uma os que não esteja em uso.
                        </DialogContentText>
                    </DialogTitle>
                    <DialogContent>
                    </DialogContent>
                </Dialog>

            </Paper >
        );
    }
}
export default RegisterActivity;